import React from 'react';
import { volumes } from '../data/content';
export function VolumesSection() {
  return <section className="border-b border-line bg-panel py-20 sm:py-24" data-id="element-279" data-mp="3uudx5tbejziq">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-280" data-mp="3uwgnkeggvunz">
        <div className="max-w-3xl" data-id="element-281" data-mp="cng1oereb36u">
          <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-acid" data-id="element-282" data-mp="cmeqmaadqgp4">
            The complete system
          </p>
          <h2 className="mt-4 font-display text-4xl font-bold uppercase leading-[0.95] tracking-tight text-white sm:text-5xl" data-id="element-283" data-mp="3g4q054a97n0t">
            Six volumes
          </h2>
        </div>

        <ul className="mt-12 grid gap-px overflow-hidden border border-line bg-line lg:grid-cols-2" data-id="element-284" data-mp="3pv13opq0zu76">
          {volumes.map(volume => <li key={volume.number} className="flex flex-col bg-panel p-7 sm:p-9" data-id="element-285" data-mp="3l39k4z5aeoqj">
              <span className="font-display text-xs font-bold uppercase tracking-[0.24em] text-acid" data-id="element-286" data-mp="2xcx6d7nd1xs1">
                {volume.number}
              </span>
              <h3 className="mt-4 font-display text-2xl font-bold uppercase leading-none tracking-tight text-white sm:text-3xl" data-id="element-287" data-mp="29g0ey1ir74ih">
                {volume.title}
              </h3>
              <p className="mt-4 text-sm leading-relaxed text-white/60 sm:text-base" data-id="element-288" data-mp="2j5br5x0xspal">
                {volume.body}
              </p>
              <p className="mt-auto pt-6 text-[11px] font-semibold uppercase tracking-[0.14em] text-white/35" data-id="element-289" data-mp="2o3d7ia6zaaid">
                {volume.topics.join(' · ')}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}